import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Previews } from './components/Previews';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2wiyvwox99na3">
      <MetaPixel data-id="element-1" data-mp="28u5z6q8t7bef" />
      <main data-id="element-2" data-mp="28tmej1rry8wp">
        <Hero data-id="element-3" data-mp="28t4lee0esat0" />
        <Stats data-id="element-4" data-mp="28sur4e8bzhhi" />
        <Testimonials data-id="element-5" data-mp="28sbad0uf2z52" />
        <PainPoints data-id="element-6" data-mp="23vkvuhy9gblr" />
        <Volumes data-id="element-7" data-mp="23w4drynwuzzs" />
        <Previews data-id="element-8" data-mp="23ujlygszdv5m" />
        <Bonuses data-id="element-9" data-mp="23v2tr4ox335x" />
        <Countdown spotsTaken={93} data-id="element-10" data-mp="23ti6m04xmmi3" />
        <Pricing data-id="element-11" data-mp="3ikqyfyb7r257" />
        <Steps data-id="element-12" data-mp="3ij66mgga9xb1" />
        <FAQ data-id="element-13" data-mp="3ijpcgysnsv8p" />
        <Countdown spotsTaken={93} data-id="element-14" data-mp="3ihuyk4ft23e4" />
        <ValueStack data-id="element-15" data-mp="3ml12h5fg3ihf" />
      </main>
      <Footer data-id="element-16" data-mp="3mjzsl4a6121a" />
    </div>;
}